import * as React from "react";
import { PageContainer } from "../../../../components";
import { DrupalRequestList } from "./DrupalRequestList";
import { DrupalCompetitionRequestList } from "./DrupalCompetitionRequestList";
import { isBrcs } from "../../../DrupalApp";

export interface IDrupalRequestListPageProps {}

export const DrupalRequestListPage: React.FunctionComponent<IDrupalRequestListPageProps> = () => {
  return (
    <PageContainer>
      <DrupalRequestList finishedOnly={false} />
      <DrupalRequestList finishedOnly={true} />
      {!isBrcs && <DrupalCompetitionRequestList />}
    </PageContainer>
  );
};
